import { useState, useCallback, useEffect, useRef } from 'react';

// 🎯 보물찾기 모드 기본 줌 레벨 (SPOT 페이지에서 선물상자 버튼 눌렀을 때와 동일)
export const TREASURE_HUNT_ZOOM = 18;

const hasValidPos = (pos) => Number.isFinite(pos?.lat) && Number.isFinite(pos?.lng);

const toMapTarget = (pos) => ({
    lat: pos.lat,
    lng: pos.lng,
    zoom: TREASURE_HUNT_ZOOM,
    timestamp: Date.now()
});

/**
 * 🎯 Treasure Hunt Mode Hook
 * 보물찾기 모드의 상태와 동작을 관리하는 커스텀 훅
 */
export const useTreasureHuntMode = ({ myPos, setMapTarget }) => {
    const [isTreasureHuntMode, setIsTreasureHuntMode] = useState(false);
    const centeredRef = useRef(false);

    // 보물찾기 모드 진입
    const enterTreasureHuntMode = useCallback(() => {
        console.log('[TreasureHunt] Entering treasure hunt mode, myPos:', myPos);
        setIsTreasureHuntMode(true);

        // 내 위치로 맵 센터링 (TREASURE_HUNT_ZOOM, 약 100m 반경 적합)
        if (hasValidPos(myPos)) {
            centeredRef.current = true;
            const targetPayload = toMapTarget(myPos);
            console.log('[TreasureHunt] Setting mapTarget:', targetPayload);
            setMapTarget(targetPayload);
        } else {
            centeredRef.current = false;
            console.warn('[TreasureHunt] myPos is null, cannot set mapTarget');
        }
    }, [myPos, setMapTarget]);

    // GPS가 진입 이후에 도착해도 한 번은 내 위치로 재센터링 (APPS→SPOT 재마운트 레이스 보완)
    useEffect(() => {
        if (!isTreasureHuntMode || centeredRef.current || !hasValidPos(myPos)) return;
        centeredRef.current = true;
        const targetPayload = toMapTarget(myPos);
        console.log('[TreasureHunt] Late GPS arrived, setting mapTarget:', targetPayload);
        setMapTarget(targetPayload);
    }, [isTreasureHuntMode, myPos, setMapTarget]);

    // 보물찾기 모드 종료
    const exitTreasureHuntMode = useCallback(() => {
        console.log('[TreasureHunt] Exiting mode, clearing mapTarget');
        centeredRef.current = false;
        setIsTreasureHuntMode(false);
        setMapTarget(null); // 🎯 [FIX] 명시적 줌 해제 -> 거리 기반 줌 복구
    }, [setMapTarget]);

    // 토글
    const toggleTreasureHuntMode = useCallback(() => {
        if (isTreasureHuntMode) {
            exitTreasureHuntMode();
        } else {
            enterTreasureHuntMode();
        }
    }, [isTreasureHuntMode, enterTreasureHuntMode, exitTreasureHuntMode]);

    return {
        isTreasureHuntMode,
        enterTreasureHuntMode,
        exitTreasureHuntMode,
        toggleTreasureHuntMode
    };
};
